import { Component, OnInit, Input, OnChanges, HostListener } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MyInterestService } from 'src/app/core/services/my-interest.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { SuccessMessageComponent } from 'src/app/components/all-modals/success-message/success-message.component';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-interests',
  templateUrl: './interests.component.html',
  styleUrls: ['./interests.component.scss']
})
export class InterestsComponent implements OnInit, OnChanges {

  @Input() public myInterests;
  @Input() public interestData;

  taggedInterestOfUser: any;
  taggedInterestToUser = [];
  selectedInterestId = [];
  deSelectedInterestId = [];
  myInterest = [];

  myInterestTaggedData: any[];
  myInterestTaggedDataOthers: any[];

  isError: boolean = false;
  errorMessage: string;
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    autoWidth: true,
    navSpeed: 500,
    // margin: 20,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      },
      1199: {
        items: 1
      }
    },
    nav: true
  }
  myInterestParent = [];
  interestInOneSlide = 19;
  windowWidth = 0;
  constructor(
    private activeModal: NgbActiveModal,
    private _myInterest: MyInterestService,
    private _spinner: NgxSpinnerService,
    private modalService: NgbModal
  ) { 
    this.windowWidth = window.innerWidth;
  }

  ngOnInit() {
    this.selectedInterestIdOfUser();
  }

  ngOnChanges() {

  }

  selectedInterestIdOfUser() {
    this._myInterest.getTaggedInterestOfUser().subscribe((response: any) => {
      if (response.success) {
        if (response.data.tagged_interests.length > 0) {
          window.localStorage.setItem('currentUserInterestSelected', 'true');
        } else {
          window.localStorage.setItem('currentUserInterestSelected', '');
        }
        this.taggedInterestOfUser = response.data.tagged_interests;

        this.myInterest.map((val) => {
          val.isTagged = false;
        });

        this.myInterest.forEach(element => {
          if (response.data.tagged_interests.indexOf(element.id) > -1) {
            element.isTagged = true;
          }
        });
        this.myInterestTaggedData = this.myInterest.filter((val) => {
          return val.isTagged === true;
        });
        this.setMyInterestParent();
      }
      else {
        this.errorMessage = response.message;
        this.isError = true;
      }
    }, (error: any) => {
      this._spinner.hide();
      // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      this.errorMessage = error;
      this.isError = true;
    })
  }
  setMyInterestParent() {
    // console.log(this.interestData);
    
    const slides = Math.ceil(this.interestData.length / this.interestInOneSlide);
    for (var i = 0; i < slides; i++) {
      this.myInterestParent[i] = this.interestData.slice((i * this.interestInOneSlide), (i * this.interestInOneSlide) + this.interestInOneSlide)
    }    
  }
  onSave() {
    this.selectedInterestId = this.interestData.filter(interest => {
      return interest.isTagged == true;
    }).map((val) => {
      return val.id;
    })
    this.deSelectedInterestId = this.interestData.filter(deSelectedInterest => {
      return deSelectedInterest.isTagged == false
    }).map((val) => {
      return val.id;
    });

    const taggedInterest = {
      tagged_interest: {
        selected_interest_ids: this.selectedInterestId,
        deselected_interest_ids: this.deSelectedInterestId
      }
    };

    this._spinner.show();
    this._myInterest.createTaggedInterestToUser(taggedInterest).subscribe((response: any) => {
      this._spinner.hide();
      if (response.success) {
        const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.INTEREST_UPDATE_SUCCESS;
        this.closeDialog();
      }
    }, (error) => {
    })
  }

  toggleInterest(interestList) {
    interestList.isTagged = !interestList.isTagged
  }

  closeDialog() {
    this.activeModal.close('success');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
  }
}
